'use client';
import { createComponent } from '../../core/create-component.js';

const P = createComponent({
    displayName: 'Paragraph',
    root: 'p'
});

export { P };
